<div class="modal-container">
  <button
    id="modalEventos"
    #modalEventos
    data-bs-toggle="modal"
    data-bs-target="#modalAlertaEventos"
    hidden="hidden"
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlertaEventos"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div 
                class="modal-content modal-content-govco">
                <div class="modal-header modal-header-govco modal-header-alerts-govco">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        (click)="cancelar()"></button>
                    </div>
                <div 
                    class="modal-body modal-body-govco">
                    <div class="p-2">
                        <app-form
                            #appFormComponent
                            [title]="isEditar ? gestionEventoText['modificar_evento']:
                            gestionEventoText['crear_evento']"
                            [fields]="fieldsModal"
                            [withSubmitButton]="false"
                            (changeAction)="onSubmitFormulario($event)"
                            (changedControl)="onSubmitEvento($event)"
                            >
                        </app-form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 col-md-12 py-3 d-flex justify-content-center">
                        <div class="d-flex flex-column flex-md-row gap-2">
                        <button
                            type="button"
                            class="btn-govco outline-btn-govco hvr-shrink"
                            (click)="confirmar()"
                            [disabled]="formEventoEntidad.invalid"
                            aria-label="Confirmar evento">
                            {{ "gestion-evento-entidad.btn-confirmar" | translate }}
                        </button>
                        <button
                            type="button"
                            class="btn-govco outline-btn-govco hvr-shrink"
                            data-bs-dismiss="modal"
                            (click)="cancelar()"
                            aria-label="Cancelar evento">
                            {{ "gestion-evento-entidad.btn-cancelar" | translate }}
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>